import { useMutation } from "@apollo/client";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory } from "react-router";
import { ROUTES } from "../../constants";
import { CREATE_EMPLOYEE, EDIT_EMPLOYEE } from "../../graphql/mutations";
import { CreateEmployeeMutation } from "../../graphql/mutations/createEmployee";
import { EditEmployeeMutation } from "../../graphql/mutations/editEmployee";
import { LIST_EMPLOYEES_FOR_LOCATION } from "../../graphql/queries";
import {
  CreateEmployeeMutationVariables,
  EditEmployeeMutationVariables,
} from "../../graphql/types";
import EmployeeForm, { EmployeeFormValues } from "./EmployeeForm";
interface Props {
  id?: string;
  open: boolean;
  initialValues?: EmployeeFormValues;
  locationId: string;
  handleClose: () => any;
  params?: object;
}

const EmployeeDialog: React.FC<Props> = ({
  open,
  handleClose,
  locationId,
  id,
  initialValues,
  params = {},
}) => {
  const isEditting = !!id;
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [add, { loading: addLoading }] = useMutation<
    CreateEmployeeMutation,
    CreateEmployeeMutationVariables
  >(CREATE_EMPLOYEE, {
    refetchQueries: [
      { query: LIST_EMPLOYEES_FOR_LOCATION, variables: { locationId } },
    ],
    onError(error) {
      console.log(error);
      enqueueSnackbar("Konnte Testpersonendaten nicht anlegen", {
        variant: "error",
      });
    },
    onCompleted() {
      enqueueSnackbar("Tespersonendaten hinzugefügt", { variant: "success" });
      handleClose();
    },
  });

  const [update, { loading: updateLoading }] = useMutation<
    EditEmployeeMutation,
    EditEmployeeMutationVariables
  >(EDIT_EMPLOYEE, {
    refetchQueries: [
      { query: LIST_EMPLOYEES_FOR_LOCATION, variables: { locationId } },
    ],
    onError(error) {
      console.log(error);
      enqueueSnackbar("Konnte Testpersonendaten nicht speicher", {
        variant: "error",
      });
    },
    onCompleted({ editEmployee = {} }) {
      const { insuranceNumber } = editEmployee || {};
      enqueueSnackbar("Tespersonendaten gespeichert", { variant: "success" });
      if (id !== insuranceNumber) {
        history.replace(`${ROUTES.EMPLOYEES}/${locationId}/${insuranceNumber}`);
      }

      handleClose();
    },

    update(cache, { data }) {
      const { editEmployee } = data || {};
      const { insuranceNumber } = editEmployee || {};

      if (id !== insuranceNumber) {
        try {
          const normalizedId = cache.identify({
            locationId,
            insuranceNumber: id,
            __typename: "Employee",
          });
          cache.evict({ id: normalizedId });
          cache.gc();
        } catch (error) {
          console.log(error);
        }
      }
    },
  });

  const handleSubmit = ({
    identifier,
    insuranceNumber,
    patient,
    address,
    birthdate,
  }: EmployeeFormValues) => {
    if (isEditting && id) {
      return update({
        variables: {
          insuranceNumber: id,
          input: {
            locationId,
            identifier,
            insuranceNumber,
            patient: {
              ...patient,
              insuranceNumber,
              ...(patient.email && { email: patient.email }),
            },
            address,
            ...(birthdate && {
              birthdate: moment(birthdate).format("YYYY-MM-DD"),
            }),
          },
        },
      });
    } else {
      return add({
        variables: {
          input: {
            locationId,
            identifier,
            insuranceNumber,
            patient: {
              ...patient,
              insuranceNumber,
              ...(patient.email && { email: patient.email }),
            },
            address,
            ...(birthdate && {
              birthdate: moment(birthdate).format("YYYY-MM-DD"),
            }),
          },
        },
      });
    }
  };

  return (
    <Dialog
      open={open}
      disableBackdropClick={addLoading || updateLoading}
      disableEscapeKeyDown={addLoading || updateLoading}
      onClose={handleClose}
      aria-labelledby="company-dialog-title"
    >
      <DialogTitle id="company-title">
        {isEditting ? "Testpersonendaten bearbeiten" : "Testpersonendaten hinzufügen"}
      </DialogTitle>
      <DialogContent>
        <EmployeeForm
          onSubmit={handleSubmit}
          loading={addLoading || updateLoading}
          initi={initialValues}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EmployeeDialog;
